import { createGlobalStyle } from 'styled-components';
import tw, { GlobalStyles as BaseStyles } from 'twin.macro';
const colors = require('tailwindcss/colors');

const CustomStyles = createGlobalStyle`
  body {
    -webkit-tap-highlight-color: ${colors.black};
    ${tw`antialiased`}
  }
`;

const GlobalStyles = () => (
  <>
    <BaseStyles />
    <CustomStyles />
  </>
);

export default GlobalStyles;
